import React, {PropTypes} from 'react';
import {defineMessages, FormattedMessage, FormattedNumber} from 'react-intl';
import * as Language from 'constants/Language';

import * as resources from 'constants/accountResourceNames';

function formatDateTime(moment) {
    return moment.format('DD-MM-YYYY, HH:mm');
}
  
const messages = defineMessages({
    title_default: {
        id: 'header.freebet.title.default',
        defaultMessage: 'Вам доступна бесплатная ставка (фрибет)'
    },
    title_promocode: {
        id: 'header.freebet.title.promocode',
        defaultMessage: 'Вам доступна бесплатная ставка (фрибет) на сумму'
    },
    maxFactor: {
        id: 'header.freebet.max_factor',
        defaultMessage: 'Распространяется на любые ставки с максимальным коэфф. {maxFactor}.'
    },
    validThru: {
        id: 'header.freebet.valid_thru',
        defaultMessage: 'Начало действия от {startDate}'
    },
    validUntil: {
        id: 'header.freebet.valid_until',
        defaultMessage: 'Срок действия до {expireDate}'
    },
    details: {
        id: 'header.freebet.details',
        defaultMessage: 'Подробнее о фрибете'
    }
});

export default class Freebet extends React.Component {
    static propTypes = {
        freebet: PropTypes.object.isRequired,
        resourceId: PropTypes.number.isRequired,
        languageId: PropTypes.number.isRequired,
        domain: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);

        this._isInsidePopup = this._isInsidePopup.bind(this);
        this._onDocumentClick = this._onDocumentClick.bind(this);

        this._boundFreebetClick = this._boundFreebetClick.bind(this);
        this._onToggleDropdown = this._onToggleDropdown.bind(this);
        this.state = {dropdownHidden: true};
    }

    componentWillMount() {
        document.addEventListener('click', this._onDocumentClick);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this._onDocumentClick);
    }

    _isInsidePopup(element) {
        if (element === null) {
            return false;
        }

        if (element === this.refs.freebet) {
            return true;
        }

        return this._isInsidePopup(element.parentElement);
    }

    _onDocumentClick(e) {
        if (this._isInsidePopup(e.target)) {
            return;
        }

        this.setState({dropdownHidden: true});
    }

    _boundFreebetClick(link, e) {
        e.preventDefault();

        window.open(link, 'Menu',
            "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
    }

    _onToggleDropdown(e) {
        e.preventDefault();

        this.setState({dropdownHidden: !this.state.dropdownHidden});
    }

    static renderAmount(amount, currency, languageId) {
        if (languageId != Language.EN) {
            return (<FormattedNumber value={amount} style="currency" currency={currency} />);
        }

        const floatAmount = parseFloat(amount).toFixed(2);

        return (
            <span>
                {currency + ' ' + floatAmount}
            </span>
        );
    }

    render() {
        const {freebet, resourceId, languageId, domain} = this.props;
        const {dropdownHidden} = this.state;
        const currency = resources.resourceNames[resourceId];

        const amount = freebet.get('amount');
        const startDate = freebet.get('startDate');
        const expireDate = freebet.get('expireDate');
        const freebetUrl = '//members.' + domain + '/bonus/freebet';
        const boundFreebetClick = this._boundFreebetClick.bind(this, freebetUrl);
        const promocodeText = freebet.get('promocodeText');

        const dropdownStyle = dropdownHidden ? {display: 'none'} : {display: 'block'};

        if (amount === undefined) {
            return false;
        }

        return (
            <div ref="freebet" className="freebet" onClick={this._onToggleDropdown}>
                <div className="freebet--icon freebet--icon__header" />
                <span className="freebet--amount">
                    {Freebet.renderAmount(amount, currency, languageId)}
                </span>
                <div className="freebet--dropdown" style={dropdownStyle}>
                    <p style={{textAlign:'left', lineHeight:'1.6'}}>
                    {promocodeText ? 
                    (
                      <FormattedMessage id="header.freebet.title.promocode" values={{
                        promocode: promocodeText,
                        sum: amount,
                        currency: currency,
                        start: formatDateTime(startDate),
                        end: formatDateTime(expireDate)
                      }}>
                        {(e) => {
                        return (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: e.replace(/\n/g, "<br/>")
                            }}
                          />
                        );
                      }}
                      </FormattedMessage>
                    ) : 
                    (
                    <FormattedMessage
                      id="header.freebet.title.default"
                      values={{
                        sum: amount,
                        currency: currency,
                        start: formatDateTime(startDate),
                        end: formatDateTime(expireDate)
                      }}
                    >
                      {(e) => {
                        return (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: e.replace(/\n/g, "<br/>")
                            }}
                          />
                        );
                      }}
                    </FormattedMessage>
                    )}
                    </p>
                    <p>
                        <a href={freebetUrl} onClick={boundFreebetClick}
                           className="content--box__btn freebet--dropdown__btn">
                            <FormattedMessage {...messages.details} />
                        </a>
                    </p>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./js/sport-betting/components/header/Freebet.jsx